import _ from 'lodash';

import { currencyOptions } from 'constants/loanFee';
import { formatNumberToCurrencyString, getNumber } from 'utils/number';

export const getWireAmountDifference = ({ calculatedWireAmount, value }) => {
  const numericValue = getNumber(String(value));
  const isNumberDifference = !_.isNil(value) && numericValue !== calculatedWireAmount;

  if (!isNumberDifference) {
    return { isNumberDifference: false, differenceStr: null };
  }

  const difference = numericValue - calculatedWireAmount;
  const differenceStr =
    difference > 0
      ? `+${formatNumberToCurrencyString(difference, currencyOptions)}`
      : formatNumberToCurrencyString(difference, currencyOptions);

  return { isNumberDifference, differenceStr };
};
